import { CustomCell } from '../../components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABLE_COLUMNS = () => [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название организации',
		field: 'name',
		flex: 2,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{ headerName: 'ИНН', field: 'inn', flex: 1, sortable: false, filterOperators: getStringOperators() },
	{ headerName: 'ОГРН', field: 'ogrn', flex: 1, sortable: false, filterOperators: getStringOperators() },
];
